import { render, staticRenderFns } from "./CoursesIndex.vue?vue&type=template&id=2b5895b0"
import script from "./CoursesIndex.vue?vue&type=script&lang=js"
export * from "./CoursesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports